import { Link } from 'react-router-dom';
import { PackageSearch, SearchX } from 'lucide-react';
import { motion } from 'framer-motion';

type Preset = 'no-devices' | 'no-results';

interface EmptyStateProps {
  variant:       Preset;
  registerHref?: string;
}

export function EmptyState({ variant, registerHref = '/devices/register' }: EmptyStateProps) {
  const isNoDevices = variant === 'no-devices';
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col items-center justify-center py-20 text-center"
    >
      <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-4 ring-1 ${
        isNoDevices
          ? 'bg-blue-50 ring-blue-100 shadow-sm'
          : 'bg-slate-50 ring-slate-200'
      }`}>
        {isNoDevices
          ? <PackageSearch className="w-8 h-8 text-blue-400" />
          : <SearchX className="w-8 h-8 text-slate-300" />
        }
      </div>
      <p className="text-slate-800 font-semibold mb-1">
        {isNoDevices ? 'No devices yet' : 'No results found'}
      </p>
      <p className="text-slate-400 text-sm mb-6 max-w-xs leading-relaxed">
        {isNoDevices
          ? 'Register your first device to get started.'
          : 'Try a different search term or status filter.'}
      </p>
      {isNoDevices && (
        <Link
          to={registerHref}
          className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-5 py-2.5 rounded-lg shadow-sm transition-colors"
        >
          Register a device
        </Link>
      )}
    </motion.div>
  );
}
